// test2656
(2656 && 0);
